// data/basis-snapshot.json: the recorded fallback for the hero readouts, the basis table and the
// checker's feed list. Fetched at runtime (the file is copied into dist/data by the build).

export interface SnapshotPoint { t: string; dex: number; oracle: number; basis: number }
export interface SnapshotHourly { t: string; close: number }

export interface SnapshotSeries {
  name: string;
  token: string;
  oracle_feed: string;
  pair_address: string;
  dex_source: string;
  multiplier: number;
  points: SnapshotPoint[];
  liquidity_usd: number;
  oracle_updated_at: string;
  last_basis: number;
  last_dex: number;
  last_oracle: number;
  last_ts: string;
  pool_hourly?: SnapshotHourly[];
  pool_hourly_source?: string;
}

export interface SnapshotMeta {
  recorded_from: string;
  recorded_to: string;
  friday_close_utc: string;
  next_open_utc: string;
  source: string;
  note: string;
  pool_hourly_note?: string;
}

export interface Snapshot {
  meta: SnapshotMeta;
  series: Record<string, SnapshotSeries>;
}

export const SNAPSHOT_URL = 'data/basis-snapshot.json';
export const CHART_URL = 'data/chart.json';

function isRecord(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null && !Array.isArray(v);
}

/** Structural check of the parts the page reads; the rest is trusted as recorded. */
export function asSnapshot(v: unknown): Snapshot {
  if (!isRecord(v) || !isRecord(v.meta) || !isRecord(v.series)) throw new Error('malformed snapshot');
  const series = v.series;
  for (const [sym, s] of Object.entries(series)) {
    if (!isRecord(s) || typeof s.token !== 'string' || typeof s.last_basis !== 'number' || !Array.isArray(s.points)) {
      throw new Error(`malformed snapshot series ${sym}`);
    }
  }
  return v as unknown as Snapshot;
}

export function feedFor(snap: Snapshot | null, addr: string): { sym: string; feed: string } | null {
  if (!snap) return null;
  const a = addr.toLowerCase();
  for (const [sym, s] of Object.entries(snap.series)) if (s.token.toLowerCase() === a) return { sym, feed: s.oracle_feed };
  return null;
}
